export default {
  reservations: 'Reservierungen',
  activated: 'Aktiviert',
  deactivated: 'Deaktiviert',
  reservations_deactivated: 'Reservierungen sind deaktiviert.',
  tabs: {
    general: 'Allgemein',
    information: 'Informationen',
  },
  sections: {
    notifications_confirmation: 'Benachrichtigungen & Bestätigung',
    notifications_confirmation_description: 'Wie Gäste buchen und wie Sie benachrichtigt werden.',
    who_can_book: 'Wer kann buchen',
    who_can_book_description: 'Personenzahl-Grenzen für Online-Reservierungen.',
    when_how_bookings_work: 'Wann & wie Buchungen funktionieren',
    when_how_bookings_work_description:
      'Zeitregeln und Kapazitätsregeln, die bestimmen, welche Zeitfenster Gäste sehen.',
  },
  google: {
    label: 'Reservierungen auf Google anzeigen',
  },
  storefront: {
    label: 'Reservierungen auf Storefront anzeigen',
  },
  auto_confirm: {
    label: 'Reservierungen automatisch bestätigen',
  },
  email: {
    label: 'E-Mail für eingehende Reservierungen',
    add: 'Email Hinzufügen',
    placeholder: 'Email eingeben',
    required: 'Bitte geben Sie mindestens eine E-Mail-Adresse für neue Reservierungen an.',
    invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  },
  has_whatsapp_phone_number: {
    label: 'Benachrichtigungen über WhatsApp senden',
  },
  whatsapp_phone_number: {
    label: 'WhatsApp-Nummer',
    add: 'WhatsApp-Nummer Hinzufügen',
  },
  party_size: {
    label: 'Zulässige Personenanzahl pro Reservierung',
    min_label: 'Min',
    max_label: 'Max',
    to: 'bis',
    guests: 'Gäste',
    helper:
      'Wie groß oder klein eine Buchung sein darf. Ein Gast kann nur für eine Personenzahl innerhalb dieses Bereichs reservieren.',
    warning:
      'Google akzeptiert nur Buchungen für 2–16 Gäste. Buchungen außerhalb dieses Bereichs funktionieren auf Ihrer Storefront, erscheinen jedoch nicht auf Google.',
    warning_min: 'Google empfiehlt mindestens 2 Gäste für Reservierungen.',
    warning_max: 'Google empfiehlt maximal 16 Gäste für Reservierungen.',
    min_note: 'Google bietet keine Reservierungen für weniger als {{count}} Personen an.',
  },
  time_slot: {
    label: 'Buchungsintervall',
    helper: 'Gäste können in diesem Minutenabstand buchen.',
    extra: 'z.B. {{example}}',
  },
  reservation_gap: {
    label: 'Buchungsstopp vor Schließung',
    helper: 'Der späteste Zeitpunkt, zu dem ein Gast eine Buchung beginnen kann, rückwärts von Ihrer Schließungszeit.',
    helper_link: 'Reservierungszeiten anzeigen',
    extra: 'z.B. Schließung um 22:00, Stopp {{example}} min → letzte buchbare Zeit ist {{example}}',
  },
  reservation_notice_period: {
    label: 'Mindestvorlaufzeit',
    helper: 'Frühestmögliche Buchungszeit vor der Ankunft.',
    extra: 'z.B. buche bis {{example}} für eine Ankunft um 18:00',
  },
  opening_times: {
    label: 'Öffnungszeiten',
  },
  total_seats: {
    label: 'Gesamte Gästekapazität',
    helper:
      'Die maximale Anzahl von Gästen (nicht Tischen), die gleichzeitig platziert werden können. Zählen Sie einzelne Plätze — z. B. 5 Tische à 4 = 20.',
  },
  capacity_explainer: {
    title: 'Wie Kapazität funktioniert',
    body: 'Dies ist die Anzahl der Gäste, die Sie gleichzeitig platzieren können. Jede Buchung reserviert Plätze für ihre Dauer und gibt sie dann für die nächsten Gäste frei. Das System hält genug Platz für alle gebuchten Gäste frei, sodass Sie nie überbucht sind.',
    body_example:
      'Beispiel: Mit 20 Plätzen können Sie um 19:00 eine 12-Personen-Buchung und um 21:00 eine 10-Personen-Buchung annehmen, da die Plätze der ersten Gruppe vor dem Eintreffen der nächsten frei werden.',
  },
  note: {
    label: 'Notiz',
  },
  grace_period: {
    label: 'Karenzzeit',
    helper: 'Wie lange ein Tisch nach Reservierungsbeginn gehalten wird.',
    tooltip:
      'Zusätzlicher Puffer nach der Reservierungsdauer, bevor der Tisch wieder angeboten wird (z. B. zum Aufräumen und Eindecken).',
    extra: 'z.B. Tisch wird bis {{example}} gehalten für eine 18:00 Buchung',
    placeholder: 'Karenzzeit eingeben',
  },
  information: {
    rules: {
      label: 'Ihr Tisch wird reserviert für:',
      add: 'Hinzufügen',
    },
  },
  reservation_duration: {
    label: 'Reservierungsdauer',
    helper: 'Wie lange ein Tisch pro Buchung gehalten wird.',
    tooltip:
      'Wie lange ein Tisch pro Buchung gehalten wird. Dies bestimmt, wann ein Tisch für den nächsten Gast wieder frei wird.',
    extra: 'z.B. 18:00 – {{example}}',
    minutes: '{{ count }} Minuten',
    hour_one: '{{ count }} Stunde',
    hour_other: '{{ count }} Stunden',
  },
  buttons: {
    save: 'Speichern',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
  },
  success_messages: {
    updated: 'Aktualisierung erfolgreich',
    saving_successful:
      'Aktualisierung erfolgreich. Bitte beachten Sie, dass Google bis zu 24 Stunden benötigen kann, um die Änderungen zu übernehmen.',
  },
  error_messages: {
    invalid_phone_number: 'Ungültige Telefonnummer',
    saving_unsuccessful: 'Fehler beim Speichern der Änderungen. Bitte versuchen Sie es erneut.',
    enter_correct_email: 'Bitte gebe eine richtige Email ein.',
  },
};
